// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21_CC","controls":"styles_controls__LfB6V","charLimit":"styles_charLimit__1fkjl","input":"styles_input__3crpu","send":"styles_send__KCPOc"};